var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUSflag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2711_3738)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2711_3738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2711_3738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H37V4.625L34.6875 6.9375L37 9.25V13.875L34.6875 16.1875L37 18.5V23.125L34.6875 25.4375L37 27.75V32.375L18.5 34.6875L0 32.375V27.75L2.3125 25.4375L0 23.125V18.5L18.5 0Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1875 4.625H37V9.25H16.1875V4.625ZM16.1875 13.875H37V18.5H18.5L16.1875 13.875ZM0 23.125H37V27.75H0V23.125ZM0 32.375H37V37H0V32.375Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.5V18.5H0V0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5137 17.5586L17.6328 14.5957H12.5742L16.6934 17.5586L15.1035 12.7168L13.5137 17.5586ZM7.66016 17.5586L11.7793 14.5957H6.7207L10.8398 17.5586L9.25 12.7168L7.66016 17.5586ZM1.80664 17.5586L5.92578 14.5957H0.867188L4.98633 17.5586L3.39648 12.7168L1.80664 17.5586ZM13.5137 11.7051L17.6328 8.74219H12.5742L16.6934 11.7051L15.1035 6.86328L13.5137 11.7051ZM7.66016 11.7051L11.7793 8.74219H6.7207L10.8398 11.7051L9.25 6.86328L7.66016 11.7051ZM1.80664 11.7051L5.92578 8.74219H0.867188L4.98633 11.7051L3.39648 6.86328L1.80664 11.7051ZM13.5137 5.7793L17.6328 2.81641H12.5742L16.6934 5.7793L15.1035 0.9375L13.5137 5.7793ZM7.66016 5.7793L11.7793 2.81641H6.7207L10.8398 5.7793L9.25 0.9375L7.66016 5.7793ZM1.80664 5.7793L5.92578 2.81641H0.867188L4.98633 5.7793L3.39648 0.9375L1.80664 5.7793Z",
    fill: "#EEEEEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2711_3738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUSflag);
export default __webpack_public_path__ + "static/media/USflag.156f757b95e7a42c79f982249a28b9c7.svg";
export { ForwardRef as ReactComponent };